import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import Modal from "react-bootstrap/Modal";
import { DM_PT_DataSheet } from "../models/DM_PT_DataSheet";
import { DeviceData } from "../models/DeviceData";
import { DM_DataSheet } from "../models/DM_DataSheet";
import { SilModal } from "./SilModal";
import { Config, isRequired, validateValueIsInRange, isNumber, ValueDesc, generateInputFields, getFirstError, getDefault } from "../formHelpers";
import { DM_DataSheet_Bar } from "../models/DM_DataSheet_Bar";

interface Props {
  closeModal: () => void;
  shownModal: string;
  deviceSheet?: DM_DataSheet_Bar;
  saveCustomDeviceSheet: (dm_dataSheet: DM_DataSheet, file: File) => void;
}

interface State {
  closeFocus: boolean;
  deviceSheet?: Partial<DM_DataSheet>;
  isClient: boolean;
}

const deviceConfig: Config<DM_DataSheet> = {
  source: {
    valueName: 'source',
    display: 'Data Source',
    inputProps: { maxLength: 5 },
    validators: [isRequired]
  },
  deviceId: {
    valueName: 'deviceId',
    display: 'Device Id',
    inputProps: { maxLength: 10 },
    validators: [isRequired]
  },
  fdfrpy: {
    valueName: 'fdfrpy',
    display: 'Failure Dangerous Failure Rate(1/ yr)',
    inputProps: { maxLength: 15 },
    validators: [validateValueIsInRange(0,1)]
  },
  fsfrpy: {
    valueName: 'fsfrpy',
    display: 'Failure Spurious Failure Rate (1/yr)',
    inputProps: { maxLength: 15 },
    validators: [validateValueIsInRange(0, 1)]
  }, 
  mtrh: {
    valueName: 'mtrh',
    display: 'Mean Time to repair(hrs)',
    inputProps: { maxLength: 5 },
    validators: [isNumber, isRequired]
  },
  ccfdm: {
    valueName: 'ccfdm',
    display: 'CCF Dual(%)',
    inputProps: { maxLength: 6 },
    validators: [validateValueIsInRange(0, 100)]

  },
  ccftm: {
    valueName: 'ccftm',
    display: 'CCF Triple(%)',
    inputProps: { maxLength: 6 },
    validators: [validateValueIsInRange(0, 100)]
  },
  deviceDescription: {
    valueName: 'deviceDescription',
    display: 'Device Type',
    type: 'textarea',
    validators: [isRequired]
  },
  dih: {
    valueName: 'dih',
    inputProps: { maxLength: 10 },
    display: 'Diagnostic Interval(hr)',
  },
  dcsm: {
    valueName: 'dcsm',
    display: 'Diagnostic Coverage Simplex(%)',
    inputProps: { maxLength: 6 },
    validators: [isRequired, isNumber]
  },
  dcdm: {
    valueName: 'dcdm',
    display: 'Diagnostic Coverage Dual(%)',
    inputProps: { maxLength: 6 },
    validators: [isRequired, isNumber]
  },
  dctm: {
    valueName: 'dctm',
    display: 'Diagnostic Coverage Triplicated(%)',
    inputProps: { maxLength: 6 },
    validators: [isRequired, isNumber]
  },
  dnts: {
    valueName: 'dnts',
    display: 'Notes',
  }
};

export class CustomerDeviceModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    var deviceSheet: Partial<DM_DataSheet> = null;
    var isClient = false;
    if (this.props.deviceSheet == null) {
      deviceSheet = getDefault(deviceConfig);
    }
    else {
      isClient = this.props.deviceSheet.isClient;
    }
    this.state = {
      closeFocus: false,
      deviceSheet: deviceSheet,
      isClient: isClient
    };
  }

  private fileRef = React.createRef<HTMLInputElement>();

  inputStyle: React.CSSProperties = {
    backgroundColor: "white"
  };

  handleClick = (e: React.MouseEvent) => {

    const file = this.fileRef.current.files[0];
    this.props.saveCustomDeviceSheet(this.state.deviceSheet as any, file);
    this.props.closeModal();
  };

  generateDeviceRow(desc: ValueDesc<DM_DataSheet>, dataSheet: Partial<DM_DataSheet>, style?: React.CSSProperties) {
    var fields = generateInputFields(dataSheet, desc, deviceSheet => {
      this.setState({ deviceSheet: deviceSheet })
    });
    var disabled = this.props.deviceSheet != null;
    function inputRow() {
      if (desc.type === 'input' || desc.type == null) {
        const defaultStyle = {
          backgroundColor: "white",
          width: "180px"
        };
        const rowStyle = style != null ? { ...defaultStyle, ...style } : defaultStyle;
        return <input
          {...fields}
          type="text"
          {...desc.inputProps}
          style={rowStyle}
          disabled={disabled}
        />
      }
      else {
        const defaultStyle = {
          backgroundColor: "white",
          height: "60px",
          width: "197px"
        };
        const rowStyle = style != null ? { ...defaultStyle, ...style } : defaultStyle;
        return <textarea
          name="txt_devicetype"
          rows={2}
          cols={20}
          {...fields}
          id="txt_devicetype"
          style={rowStyle}
          disabled={disabled}
        />
      }
    }

    // todo deal with diabled
    return <React.Fragment>
      <tr>
      <td className="custom_device">
        <span id="Label18">{desc.display}</span>
      </td>
      <td className="custom_device_text">
        {
          inputRow()
        }
      </td>
    </tr>
    </React.Fragment>
  }
  
  render() {
    const deviceSheet = this.props.deviceSheet != null ? { ...this.props.deviceSheet.dataSheet } : { ...this.state.deviceSheet };

    // this is due to weird conversion between user displayable values, and database stored values. See ProtectiveFunctionHtml.aspx.cs/SaveCustomDeviceSheet
    if (this.props.deviceSheet != null) {
      deviceSheet.ccfdm *= 100;
      deviceSheet.ccftm *= 100;
      deviceSheet.dcsm *= 100;
      deviceSheet.dcdm *= 100;
      deviceSheet.dctm *= 100;
    }

    const generateRow = (desc: ValueDesc<DM_DataSheet>, style?: React.CSSProperties) => this.generateDeviceRow(desc, deviceSheet, style);

    var firstError = getFirstError<DM_DataSheet>(deviceSheet, deviceConfig);
    return (
      <SilModal title="Customer Device" closeModal={this.props.closeModal}>
        <div
          id="devicepopup"
          style={{
            width: "auto",
            display: "block",
            minHeight: "98.8667px",
            height: "auto"
          }}
          className="ui-dialog-content ui-widget-content"
        >
          <div
            style={{ float: "left", width: "50%", display: "inline-block" }}
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    <table>
                      <tbody>
                        {generateRow(deviceConfig.source, { width:"130px"})}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        {generateRow(deviceConfig.deviceId, { width: "115px" })}
                      </tbody>
                    </table>
                  </td>
                </tr>
                {generateRow(deviceConfig.fdfrpy)}
                {generateRow(deviceConfig.fsfrpy)}
                {generateRow(deviceConfig.mtrh)}
                {generateRow(deviceConfig.ccfdm)}
                {generateRow(deviceConfig.ccftm)}
              </tbody>
            </table>
          </div>
          <div
            style={{ float: "right", display: "inline-block", width: "50%" }}
          >
            <table>
              <tbody>
                {generateRow(deviceConfig.deviceDescription)}
                {generateRow(deviceConfig.dih, { width: "197px" })}
                {generateRow(deviceConfig.dcsm, { width: "197px" })}
                {generateRow(deviceConfig.dcdm, { width: "197px" })}
                {generateRow(deviceConfig.dctm, { width: "197px" })}
              </tbody>
            </table>
          </div>
          <span id="Label37">Notes</span>
          <br />
          <textarea rows={2} cols={20}
            disabled={this.props.deviceSheet != null ? true : false}
            style={{
              backgroundColor: "white",
              height: "100px",
              width: "905px"
            }}
            {...generateInputFields(deviceSheet, deviceConfig.dnts, (obj) => this.setState({ deviceSheet: obj }))} />
          <div className="form-group">
            <label htmlFor="devicefileimage">
              Select Alternate User Image File (optional):
            </label>
            <input
              type="file"
              multiple={true}
              name="DeviceFileUpload"
              id="DeviceFileUpload"
              ref={this.fileRef}
            />
            <p className="help-block">
              Select the image file to represent this custom device.
            </p>
          </div>
          {firstError != null ? <div className="custom-errors"><label>{firstError}</label></div> : ''}
            
          {this.props.deviceSheet == null ? (
            <div style={{ textAlign: "center" }}>
              <input
                type="submit"
                name="Btn_device_save"
                defaultValue="Save"
                id="Btn_device_save"
                disabled={firstError != null}
                className={firstError != null ? 'disabled green-button' : 'green-button'}
                onClick={(e: React.MouseEvent) => this.handleClick(e)}
              />
              <input
                type="submit"
                name="Customer_Device_Update"
                defaultValue="Update"
                className="edit-button"
                id="Customer_Device_Update"
                style={{ display: "none" }}
              />
            </div>
          ) : null}
      </div>
      </SilModal>
    );
  }
}
